import React, { useCallback, CSSProperties } from 'react';
import { Grid, Box, FormControlLabel, Checkbox } from '@material-ui/core';
import useStyles from './styles';
import cx from 'classnames';

interface IProps {
  id: number;
  keyword: string;
  isEditing: boolean;
  highlightKeywordId?: number;
  onClickCheckbox: (id: number) => void;
  isChecked: boolean;
  style: CSSProperties;
}

const KeywordCell = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { style, id, isEditing, keyword, isChecked, onClickCheckbox, highlightKeywordId } = props;

  const handleChange = useCallback(
    e => {
      const id = parseInt(e.target.value, 10);

      onClickCheckbox(id);
    },
    [onClickCheckbox],
  );

  return (
    <Grid key={id} item xs={4} style={style}>
      <Box className={classes.lateNightKeywordCell}>
        {isEditing === true ? (
          <FormControlLabel
            control={<Checkbox color="primary" value={id} checked={isChecked} onChange={handleChange} />}
            label={keyword}
            classes={{
              label: classes.lateNightKeywordCellLabel,
            }}
          />
        ) : (
          <span className={cx({ [classes.notify]: id === highlightKeywordId })}>{keyword}</span>
        )}
      </Box>
    </Grid>
  );
};

export default React.memo(KeywordCell);
